import client from '../utils/client'
import { gql } from '@apollo/client'

import { MutationHandlerResult } from '../utils/errors'

const GET_STRIPE_LINK = gql`
	mutation GetStripeLink($restaurantId: ID!, $isTest: Boolean!) {
		getStripeLink(restaurantId: $restaurantId, isTest: $isTest) {
			success
			url
		}
	}
`

const getStripeLink = async ({
	restaurantId,
	isTest,
}: {
	restaurantId: string
	isTest: boolean
}): Promise<MutationHandlerResult & { url?: string | null }> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: GET_STRIPE_LINK,
			variables: { restaurantId, isTest },
		})

		if (errors) {
			return { success: false, errors }
		}

		return {
			success: true,
			errors: null,
			url: data?.getStripeLink?.url ?? null,
		}
	} catch (e: unknown) {
		if (e && typeof e === 'object' && 'networkError' in e)
			return { success: false, errors: 'NETWORK_ERROR' }
		throw e
	}
}

export default getStripeLink
